import { useCallback } from 'react'

import { ContactDeactivationHeader } from 'clickNgo/features/contact/contactDeactivation/components/contactDeactivationHeader'
import { contactRelinkingModalTranslations } from 'clickNgo/features/contact/contactRelinking/contactRelinkingValidationModal/translation'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './SkipStepWarning.module.scss'

interface ISkipStepWarningProps {
  isVisible: boolean
  handleSkipConfirmationClose: () => void
  handleSkipConfirmationProceed: () => void
  skipTranslations: {
    title: string
    description: string
  }
}

export const SkipStepWarning = ({
  isVisible,
  skipTranslations,
  handleSkipConfirmationProceed,
  handleSkipConfirmationClose,
}: ISkipStepWarningProps) => {
  const renderSkipConfirmationContent = useCallback(() => {
    return (
      <>
        <ContactDeactivationHeader
          title={skipTranslations.title}
          description={skipTranslations.description}
        />
        <div className={styles.confirmButtons}>
          <Button onClick={handleSkipConfirmationClose} color="danger" variant="text">
            <Translation text={contactRelinkingModalTranslations.skipConfirm.buttons.cancel} span />
          </Button>
          <Button onClick={handleSkipConfirmationProceed}>
            <Translation
              text={contactRelinkingModalTranslations.skipConfirm.buttons.confirm}
              span
            />
          </Button>
        </div>
      </>
    )
  }, [
    handleSkipConfirmationClose,
    handleSkipConfirmationProceed,
    skipTranslations.description,
    skipTranslations.title,
  ])

  return (
    <ModalDialog
      show={isVisible}
      onClose={handleSkipConfirmationClose}
      closeOnOutsideClick={false}
      content={renderSkipConfirmationContent}
      size="sm"
    />
  )
}
